import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import EventBus from './event-bus'
import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN'

Validator.addLocale(zh)

const config = {
locale: 'zh_CN',
errorBagName: 'vErrors'
}

export default () => {
Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(EventBus)
Vue.use(VeeValidate, config)
Vue.use(WechatPlugin)
Vue.use(ConfirmPlugin)
}




// WEBPACK FOOTER //
// ./src/plugins/setup.js